<template>
  <v-row class="customer-detail custom-border-to">
    <v-col md="12" sm="12" class="pt-0">
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        type="table-tbody"
      >
      </v-skeleton-loader>
      <v-simple-table v-else class="simple-table">
        <template v-slot:default>
          <thead>
            <tr style="background-color: #f3f6f9; color: #24326d">
              <th class="simple-table-th">Cost Category</th>
              <th class="simple-table-th">SBU</th>
              <th width="300" class="simple-table-th">External Vendor</th>
              <th class="simple-table-th">Rate</th>
              <th class="simple-table-th">Unit</th>
              <th class="simple-table-th">Quantity</th>
              <th class="simple-table-th">Amount</th>
              <th class="simple-table-th">Status</th>
              <th class="simple-table-th">Accepted/Rejected Remark</th>
              <th class="simple-table-th">Action</th>
            </tr>
          </thead>
          <tbody>
            <template v-if="rowData && rowData.length">
              <tr
                v-for="(budget, index) in rowData"
                :key="index"
                :class="{
                  'custom-border-top': index == 0,
                  'orange_lighten-5': index % 2 == 0,
                  'budget-row-locked': !isBudgetEditable(budget),
                }"
                :title="
                  !isBudgetEditable(budget)
                    ? 'Accepted or rejected budgets cannot be edited.'
                    : ''
                "
              >
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500 text-capitalize"
                >
                  <v-chip label outlined color="cyan" small>
                    {{ budget.cost_category_name }}
                  </v-chip>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <template v-if="budget.sbu_name">
                    {{ budget.sbu_name }}
                  </template>
                  <em v-else class="text-muted"> no sbu </em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500 text-lowercase"
                >
                  <template v-if="budget.external_vendor">
                    <div class="line-climp-content">
                      {{ budget.external_vendor }}
                    </div>
                  </template>
                  <em v-else class="text-muted"> no vendor </em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <template v-if="budget.rate">
                    {{ budget.rate }}
                  </template>
                  <em v-else class="text-muted">0.00</em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <template v-if="budget.unit">
                    {{ budget.unit_name }}
                  </template>
                  <em v-else class="text-muted">-</em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <template
                    v-if="
                      budget.quantity !== null &&
                      budget.quantity !== undefined &&
                      budget.quantity !== ''
                    "
                  >
                    {{ parseFloat(budget.quantity).toFixed(2) }}
                  </template>
                  <em v-else class="text-muted">0.00</em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <template
                    v-if="
                      budget.amount !== null &&
                      budget.amount !== undefined &&
                      budget.amount !== ''
                    "
                  >
                    {{ parseFloat(budget.amount).toFixed(2) }}
                  </template>
                  <em v-else class="text-muted">0.00</em>
                </td>
                <td
                  link
                  v-on:click="selectBudget(budget)"
                  class="font-size-18 font-weight-500"
                >
                  <v-chip
                    label
                    outlined
                    color="blue darken-4 text-capitalize"
                    small
                  >
                    {{ budget.status_name }}
                  </v-chip>
                </td>
                <td class="font-size-14 font-weight-500">
                  <v-tooltip
                    top
                    v-if="budget.accepted_rejected_remark"
                    content-class="budget-remark-tooltip"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <span v-bind="attrs" v-on="on" class="cursor-pointer">
                        {{
                          budget.accepted_rejected_remark.length > 30
                            ? `${budget.accepted_rejected_remark.substring(
                                0,
                                30
                              )}...`
                            : budget.accepted_rejected_remark
                        }}
                      </span>
                    </template>
                    <span>{{ budget.accepted_rejected_remark }}</span>
                  </v-tooltip>
                  <em v-else class="text-muted">-</em>
                </td>
                <td class="font-size-18 font-weight-500">
                  <v-btn
                    v-if="isApprover(budget) && budget.status == 1"
                    class="mx-2 mb-1 custom-bold-button white--text"
                    color="success"
                    x-small
                    rounded
                    @click="openDialog(budget, 'accept')"
                  >
                    Accept
                  </v-btn>
                  <v-btn
                    v-if="isApprover(budget) && budget.status == 1"
                    class="mx-2 custom-bold-button white--text"
                    color="red"
                    x-small
                    rounded
                    @click="openDialog(budget, 'reject')"
                  >
                    Reject
                  </v-btn>
                  <div v-else class="mx-2">
                    <span>-</span>
                  </div>
                </td>
              </tr>
            </template>
            <template v-else>
              <tr>
                <td colspan="10">
                  <p
                    class="m-0 row-not-found text-center font-weight-500 font-size-16"
                  >
                    <img
                      :src="$assetURL('media/error/empty.png')"
                      class="row-not-found-image"
                    />
                    Uhh... There are no budget at the moment.
                  </p>
                </td>
              </tr>
            </template>
            <Dialog :common-dialog="action_dialog">
              <template v-slot:title> Confirmation </template>

              <template v-slot:body>
                <v-form ref="form" v-model="formValid">
                  <v-container>
                    <p class="font-size-19 font-weight-600 mx-2 my-0">
                      Are you sure, you want to
                      <span
                        class="font-weight-700"
                        :class="{
                          'red--text text--lighten-1': action_type === 'reject',
                          'green--text text--lighten-1':
                            action_type === 'accept',
                        }"
                      >
                        {{ action_type === "accept" ? "accept" : "reject" }}
                      </span>
                      this budget?
                    </p>
                    <div class="mt-3">
                      <label class="input-label required mb-1">
                        {{
                          action_type === "accept"
                            ? "Accept Remark"
                            : "Reject Remark"
                        }}
                      </label>

                      <v-textarea
                        v-model="remark"
                        auto-grow
                        dense
                        filled
                        color="cyan"
                        solo
                        flat
                        placeholder="Enter remark"
                        row-height="15"
                        maxlength="250"
                        counter="250"
                        :rules="[validateRules.required(remark, 'Remark')]"
                      ></v-textarea>
                    </div>
                  </v-container>
                </v-form>
              </template>

              <template v-slot:action>
                <v-btn
                  depressed
                  class="mx-2 custom-grey-border custom-bold-button white--text"
                  :color="action_type === 'accept' ? 'success' : 'red'"
                  @click="action_submit"
                  :disabled="!remark || formLoading"
                  :loading="formLoading"
                >
                  {{ action_type === "accept" ? "Accept" : "Reject" }}
                </v-btn>

                <v-btn
                  depressed
                  :disabled="formLoading"
                  class="mx-2 custom-grey-border custom-bold-button"
                  @click="action_dialog = false"
                >
                  Cancel
                </v-btn>
              </template>
            </Dialog>
          </tbody>
        </template>
      </v-simple-table>
    </v-col>
  </v-row>
</template>

<script>
import CommonMixin from "@/core/plugins/common-mixin";
import { PUT } from "@/core/services/store/request.module";
import JwtService from "@/core/services/jwt.service";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ValidationMixin from "@/core/plugins/validation-mixin";

export default {
  name: "budget-listing",
  title: "Budget",
  mixins: [CommonMixin, ValidationMixin],
  props: {
    budgets: {
      type: Array,
      required: true,
      default: function () {
        return [];
      },
    },
    pageLoading: {
      type: Boolean,
      default: true,
    },
    quotationId: {
      type: Number,
      required: true,
    },
  },
  components: {
    Dialog,
  },
  data() {
    return {
      rowData: [],
      selectedRows: [],
      CurrentUser: new Object(),

      statusDialog: false,
      dialogType: null, // 'accept' | 'reject'
      selectedBudget: null,

      action_dialog: false,
      action_type: null,
      formLoading: false,
      remark: "",
      formValid: true,
    };
  },
  watch: {
    selectedRows(param) {
      this.$emit("selectedRows", param);
    },
    budgets: {
      deep: true,
      immediate: true,
      handler() {
        this.assignData();
      },
    },
  },
  methods: {
    openDialog(budget, type) {
      this.selectedBudget = budget;
      this.action_type = type;
      this.remark = "";
      this.action_dialog = true;
    },

    action_submit() {
      const _this = this;
      if (!_this.$refs.form.validate()) return;
      const status = _this.action_type === "accept" ? 2 : 3;

      _this.formLoading = true;

      _this.$store
        .dispatch(PUT, {
          url: `quotation-budget-status/${_this.quotationId}/${_this.selectedBudget.id}`,
          data: {
            status: status,
            remark: _this.remark,
          },
        })
        .finally(() => {
          _this.formLoading = false;
          _this.action_dialog = false;
          _this.$emit("success");
        });
    },
    isBudgetEditable(budget) {
      const status = Number(budget.status);
      return status !== 2 && status !== 3;
    },
    selectBudget(param) {
      if (!this.isBudgetEditable(param)) return;
      this.$emit("selectBudget", param);
    },
    assignData() {
      const _this = this;
      if (
        Array.isArray(_this.budgets) &&
        _this.lodash.isEmpty(_this.budgets) === false
      ) {
        _this.rowData = _this.budgets;
      } else {
        _this.rowData = [];
      }
    },
    isApprover(budget) {
      const userId = this.CurrentUser?.id;

      if (!userId || !budget.approver_ids) return false;

      return budget.approver_ids.includes(userId);
    },
    getUserProfile() {
      const _this = this;
      try {
        _this.CurrentUser = JwtService.currentUser();
      } catch (error) {
        _this.logError(error);
        _this.onLogout();
      }
    },
  },
  mounted() {
    const _this = this;
    _this.assignData();
    _this.$root.$on("clearSelection", () => {
      _this.selectedRows = [];
    });
    _this.getUserProfile();
  },
  beforeDestroy() {
    /*this.$root.$off("clearSelection");*/
  },
  computed: {
    hasAcceptedBudget() {
      if (!this.rowData || !this.rowData.length) {
        return false;
      }
      return this.rowData.some(
        (budget) =>
          budget.status_name && budget.status_name.toLowerCase() === "accepted"
      );
    },
    selectedAll: {
      set(param) {
        this.selectedRows = [];
        if (param && this.rowData && this.rowData.length) {
          for (let i = this.rowData.length - 1; i >= 0; i--) {
            this.selectedRows.push(this.rowData[i].id);
          }
        }
      },
      get() {
        let totalItems = this.rowData ? this.rowData.length : 0;
        return totalItems > 0 ? this.selectedRows.length === totalItems : false;
      },
    },
  },
};
</script>

<style scoped>
.budget-row-locked td[link] {
  cursor: default;
}

::v-deep .budget-remark-tooltip {
  width: 200px !important;
  max-width: 200px !important;
  min-width: 0 !important;
  white-space: normal !important;
  overflow-wrap: anywhere;
}
</style>

<style>
.budget-remark-tooltip {
  width: 280px !important;
  max-width: 280px !important;
  min-width: 0 !important;
  z-index: 99999 !important;
  white-space: normal !important;
  overflow-wrap: anywhere !important;
}
</style>
